<template>
  <div>
    <navigationBar :fill="true" />
    <div class="login-warrp full-height">
      <div>
        <router-link class="title" to="/login">已有账户，立即登录</router-link>
        <!-- <router-link class="title" to="/login">建设网站，从<span class="active">域名注册</span>开始</router-link> -->
        <div style="margin-bottom: 65px;">
          <p class="text">我们诚挚地邀请各位开发者朋友，以及企业的朋友，和我们分享您的云产品使用体验，分享您的每一步跨越</p>
        </div>
        <div style="text-align: center;">
          <Input class="bg-color-303240 height-62 login-input" style="margin-bottom: 20px;" v-model.trim="form.name" clearable :placeholder="step == 0 ? '用户ID/手机号码/账户邮箱' : '手机号码/账户邮箱'" />
        </div>
        <div style="text-align: center;">
          <Input type="password" v-if="step === 0" class="bg-color-303240 height-62 login-input" v-model.trim="form.password" clearable placeholder="请输入密码" />
        </div>
        <div class="width-500" style="display: flex;" v-if="step === 1">
           <Input
            class="bg-color-303240 height-62  login-input"
            type="text"
            placeholder="请输入验证码"
            clearable
            v-model="form.code"
            style="width: 400px"
            @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
          >
          </Input>
          <Button
              ref="smsBtn"
              class="sms-btn"
              shape="circle"
              height="60px"
              @click="refreshCode"
              :disabled="codeDisabled"
              style="width: 120px; height: 62px"
          >{{text1}}</Button>
        </div>
        <div class="width-500">
          <div class="flex-content-between" style="margin-top: 25px">
            <Checkbox class="color-C4332E remember" v-model="single"> 记住我</Checkbox>
            <div class="actives" @click="stepClick">{{ text }}</div>
            <router-link class="forgot" to="/forgot">忘记密码？</router-link>
          </div>
          <Button class="login-btn" style="margin-top: 25px;" long :loading="loading" @click="submit">登录</Button>
          <router-link class="sige" to="/sige">没有账户，<span class="actives">免费注册</span>！</router-link>
        </div>
      </div>

    </div>
    <Modal
        v-model="verifyshow"
        title="验证码"
        @on-ok="getCodeEvent"
        @on-cancel="verifyshow = false">
      <div class="verify-info">
        <div class="verify-code">
          <span class="verify-label">验证码</span>
          <div class="verify-block">
            <img id="verificationCode" class="verify-img" @click="refreshCode">
          </div>
        </div>
        <input
            v-model="codeValue"
            class="verify-input"
            placeholder="请输入验证码"
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import navigationBar from "components/navigationBar.vue";
import smsBtn from "components/smsBtn.vue";
import { mapMutations, mapState } from "vuex";
import { getEncrypt } from "utils/encrypt";
import { getLoginCode, login, getAmountInfo, getMemberInfo } from "api/user.js";
import { Base64 } from "js-base64";
import { API_BASE_URL } from "@/utils/config";
export default {
  name: "login",
  components: {
    navigationBar,
    smsBtn,
  },
  data() {
    return {
      step: 0, // 0 密码登录 1 短信登录
      single: false,
      form: {
        name: "",
        password: "",
        code: "",
      },
      loading: false,
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text1: "获取验证码",
      codeDisabled: false
    };
  },
  watch: {
    step: {
      immediate: true,
      handler(val) {
        if (val === 0) {
          const rememberMe = localStorage.getItem("U_RememberMe");
          if (rememberMe && rememberMe === "true") {
            this.form.name = localStorage.getItem("U_ID");
            this.form.password = Base64.decode(
              localStorage.getItem("U_Secret")
            );
          }
          this.single = rememberMe === "true";
        }
      },
    },
  },
  computed: {
    ...mapState(["prevRouter"]),
    text() {
      return this.step === 0 ? "短信/邮箱验证登录" : "密码登录";
    },
  },
  methods: {
    refreshCode() {
      if (!this.form.name || this.form.name === '') {
        return this.$Message.warning('手机号不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${API_BASE_URL}/hkweb/dx/login/validateCode?mobile=${this.form.name}`
      }, 0)
    },
    ...mapMutations(["MUT_TOKEN_INFO", "MUT_AMOUNT", "MUT_USER_INFO"]),
    stepClick() {
      this.step = this.step === 0 ? 1 : 0;
    },
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$Message.warning("图形验证码不能为空！");
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码！");
        this.$refs.smsBtn.reset();
        return;
      }
      getLoginCode(this.form.name, this.codeValue)
        .then((res) => {
          if (res.code === 200 && res.result) {
            let i = 60;
            this.text1 = `${i--}秒后再获取`;
            this.codeDisabled = true
            this.getCodeInterval = setInterval(() => {
              if (i <= 1) {
                this.text1 = "获取验证码";
                clearInterval(this.getCodeInterval);
                this.codeDisabled = false
                return;
              }
              this.text1 = `${i--}秒后再获取`;
            }, 1000);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    submit() {
      if (!this.form.name) {
        this.$Message.warning("请输入用户ID/手机号码/账户邮箱！");
        return false;
      }
      if (this.step === 1) {
        if (!this.form.code) {
          this.$Message.warning("请输入验证码！");
          return false;
        }
      }else{
        if (!this.form.password) {
          this.$Message.warning("请输入密码！");
          return false;
        }
      }

      let params = {
        user: this.form.name,
        type: this.step,
        s: 0,
      };

      this.step === 0
        ? (params["p"] = getEncrypt(this.form.password))
        : (params["code"] = this.form.code);
      this.loading = true;
      login(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200 && res.result) {
            if (this.single) {
              localStorage.setItem("U_ID", this.form.name);
              localStorage.setItem(
                "U_Secret",
                Base64.encode(this.form.password)
              );
              localStorage.setItem("U_RememberMe", this.single);
            }
            this.MUT_TOKEN_INFO(res.data);
            Promise.all([getAmountInfo(), getMemberInfo()]).then((res2) => {
              const { code, data, result } = res2[0];
              const { code: code2, data: data2, result: result2 } = res2[1];
              if (code === 200 && result) {
                this.MUT_AMOUNT(data);
              }
              if (code2 === 200 && result2) {
                this.MUT_USER_INFO(data2);
              }
              this.$Message.success("登录成功!");
              this.$router.replace(this.prevRouter);
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.login-warrp{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1200px;

  margin: 0 auto;
  .title{
    display: block;
    text-align: center;
    font-size: 48px;
    color: #333333;
    margin-bottom: 30px;
    .active{
      color: #288DF0;
    }
  }
  .text{
    font-size: 20px;
    line-height: 50px;
    color: #666666;
    text-align: center;
  }
  .actives {
    cursor: pointer;
    color: #288DF0;
    font-weight: 400;
    font-size: 16px;
  }
  .sige{
    display: block;
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
    text-align: left;
  }
  .forgot,.remember{
    font-size: 16px;
    color: #288DF0;
  }
  .width-500{
    width: 500px;
    margin: 0 auto;
    text-align: center;
  }
  /deep/.sms-btn{
    margin-left: 20px;
    .ivu-btn{
      width: 120px;
      background-color: #288DF0;
      color: #fff;
      border-color:#288DF0;
    }

  }
}
.verify-info {
  padding: 15px 30px;
}
.verify-label {
  background-color: #f7fafb;
  width: 80px;
  font-size: 14px;
  padding: 0 15px;
  line-height: 58px;
  text-align: center;
}
.verify-code {
  border: 1px solid #e9eaec;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.verify-input {
  display: block;
  width: 100%;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  outline: none;
  padding: 0 20px;
  line-height: 40px;
  box-sizing: border-box;
}
.verify-block {
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-left: 10px;
}
::v-deep .ivu-modal-content {
  background-color: #fff!important;
}
.sms-btn /deep/ {
  .ivu-btn {
    width: 100%;
    height: 100%;
    background-color: #288DF0;
    color: #fff;
    &:hover{
      border-color: #3E99D4;
    }
  }
}
::v-deep .ivu-btn-primary {
  color: #fff;
  background-color: #288DF0;
  border-color: #288DF0;
}
</style>
